import React from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import ScCanvas from "./scCanvas/ScCanvas";
import "./scDesigner.css";
import ScProperties from "./scProperties/ScProperties";
import ScToolbar from "./scToolbar/ScToolbar";
import ScTopbar from "./scTopbar/ScTopbar";
const ScDesigner = () => {
  return (
    <>
      <div className="container">
        <div className="row mb-2">
          <ScTopbar />
        </div>

        <div className="row">
          <DndProvider backend={HTML5Backend}>
            <div className="col-sm-2 mx-auto overflow-auto">
              <ScToolbar />
            </div>
            <div className="col-sm-6">
              <ScCanvas />
            </div>
            <div className="col-sm-4">
              <ScProperties />
            </div>
          </DndProvider>
        </div>
      </div>
    </>
  );
};

export default ScDesigner;
